import { render, staticRenderFns } from "./managerWordDetail.vue?vue&type=template&id=816bbf2a"
import script from "./managerWordDetail.vue?vue&type=script&lang=js"
export * from "./managerWordDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports